function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Pressable, TextInput, View } from 'react-native';
import { BLUE_600 } from '../../constants';
import { InfoIcon } from '../../icons';
import { StateConfigContext } from '../../providers';
import { checkIsPlatform, getTestId } from '../../utils';
import { Button } from '../button';
import { Tooltip } from '../tooltip';
import { Typography } from '../typography';
import { AnimatedPlaceholder } from './components/animated-placeholder';
import { InputPrependAppendItem } from './components/input-prepend-append-item';
import { getCharacterCounter, getInputInitialStyles, getInputProps, getInputStyles, getRemainingCharacterCounter } from './InputStyles';
import { OtpFields } from './components/otp-field/OtpFields';
export var Input = forwardRef((props, ref) => {
  var stateContext = useContext(StateConfigContext);
  var inputProps = getInputProps(props, stateContext);
  var stylesBasedOnState = useRef({});
  var theme = inputProps.theme,
    containerStyle = inputProps.containerStyle,
    label = inputProps.label,
    showLabelIcon = inputProps.showLabelIcon,
    onLabelIconPress = inputProps.onLabelIconPress,
    _inputProps$showLabel = inputProps.showLabelTooltipOnMount,
    labelTooltip = _inputProps$showLabel === void 0 ? false : _inputProps$showLabel,
    labelTooltipProps = inputProps.labelTooltipProps,
    labelAccessibilityProps = inputProps.labelAccessibilityProps,
    inputRegex = inputProps.inputRegex,
    enableOtp = inputProps.enableOtp,
    otpFieldLength = inputProps.otpFieldLength,
    maskedLength = inputProps.maskedLength,
    textInputOverrides = inputProps.textInputOverrides,
    validationRegex = inputProps.validationRegex,
    validationRegexFlag = inputProps.validationRegexFlag,
    invalidMsgForValidationRegex = inputProps.invalidMsgForValidationRegex,
    onValidInput = inputProps.onValidInput,
    onInValidInput = inputProps.onInValidInput,
    showPrepend = inputProps.showPrepend,
    prependItems = inputProps.prependItems,
    showAppend = inputProps.showAppend,
    appendItems = inputProps.appendItems,
    hintTextProp = inputProps.hintText,
    hintTextAccessibilityProps = inputProps.hintTextAccessibilityProps,
    useStateHintColorProp = inputProps.useStateHintColor,
    isDisabled = inputProps.isDisabled,
    stateProp = inputProps.state,
    readOnly = inputProps.readOnly,
    hintActionText = inputProps.hintActionText,
    hintActionTextAccessibilityProps = inputProps.hintActionTextAccessibilityProps,
    showLoader = inputProps.showLoader,
    actionCta = inputProps.actionCta,
    style = inputProps.style,
    _valueProp = inputProps.value,
    defaultValue = inputProps.defaultValue,
    showClearButton = inputProps.showClearButton,
    onHintActionPressHandler = inputProps.onHintActionPressHandler,
    onChangeText = inputProps.onChangeText,
    onClearButtonPress = inputProps.onClearButtonPress,
    noTextTransformHintAction = inputProps.noTextTransformHintAction,
    showAsTextArea = inputProps.showAsTextArea,
    readOnlyOnPress = inputProps.readOnlyOnPress,
    placeholder = inputProps.placeholder,
    _onFocus = inputProps.onFocus,
    _onBlur = inputProps.onBlur,
    showCharacterCounter = inputProps.showCharacterCounter,
    _inputProps$showRemai = inputProps.showRemainingCharacterCounter,
    showRemainingCharacterCounter = _inputProps$showRemai === void 0 ? false : _inputProps$showRemai,
    _inputProps$placehold = inputProps.placeholderList,
    placeholderList = _inputProps$placehold === void 0 ? [] : _inputProps$placehold,
    _inputProps$preventOn = inputProps.preventOnChangeText,
    preventOnChangeText = _inputProps$preventOn === void 0 ? false : _inputProps$preventOn,
    _inputProps$testID = inputProps.testID,
    testID = _inputProps$testID === void 0 ? 'Input' : _inputProps$testID,
    size = inputProps.size,
    variantStyle = inputProps.variantStyle,
    parentAccessibilityProps = inputProps.parentAccessibilityProps,
    restProps = __rest(inputProps, ["theme", "containerStyle", "label", "showLabelIcon", "onLabelIconPress", "showLabelTooltipOnMount", "labelTooltipProps", "labelAccessibilityProps", "inputRegex", "enableOtp", "otpFieldLength", "maskedLength", "textInputOverrides", "validationRegex", "validationRegexFlag", "invalidMsgForValidationRegex", "onValidInput", "onInValidInput", "showPrepend", "prependItems", "showAppend", "appendItems", "hintText", "hintTextAccessibilityProps", "useStateHintColor", "isDisabled", "state", "readOnly", "hintActionText", "hintActionTextAccessibilityProps", "showLoader", "actionCta", "style", "value", "defaultValue", "showClearButton", "onHintActionPressHandler", "onChangeText", "onClearButtonPress", "noTextTransformHintAction", "showAsTextArea", "readOnlyOnPress", "placeholder", "onFocus", "onBlur", "showCharacterCounter", "showRemainingCharacterCounter", "placeholderList", "preventOnChangeText", "testID", "size", "variantStyle", "parentAccessibilityProps"]);
  var valueProp = "" + (_valueProp !== null && _valueProp !== void 0 ? _valueProp : '');
  var _useState = useState(valueProp),
    value = _useState[0],
    setValue = _useState[1];
  var _useState2 = useState(),
    prevValue = _useState2[0],
    setPrevValue = _useState2[1];
  var showClearBtn = (value === null || value === void 0 ? void 0 : value.length) > 0 && showClearButton;
  var _useState3 = useState(stateProp),
    state = _useState3[0],
    setState = _useState3[1];
  var disabledTextInput = isDisabled || state === 'disabled';
  var readOnlyTextInput = readOnly || state === 'readonly';
  var blockEdit = disabledTextInput || readOnlyTextInput;
  var _useState4 = useState(false),
    isInputFocused = _useState4[0],
    setIsInputFocused = _useState4[1];
  var _useState5 = useState(hintTextProp),
    hintText = _useState5[0],
    setHintText = _useState5[1];
  var _useState6 = useState(labelTooltip),
    showLableTooltip = _useState6[0],
    setShowLableTooltip = _useState6[1];
  var _useState7 = useState(useStateHintColorProp),
    useStateHintColor = _useState7[0],
    setUseStateHintColor = _useState7[1];
  var hasPlaceholderList = (placeholderList === null || placeholderList === void 0 ? void 0 : placeholderList.length) > 0;
  var inputStyles = getInputInitialStyles(Object.assign(Object.assign({}, inputProps), {
    state,
    useStateHintColor
  }));
  useEffect(() => {
    setUseStateHintColor(useStateHintColorProp);
  }, [useStateHintColorProp]);
  useEffect(() => {
    setState(stateProp);
  }, [stateProp]);
  useEffect(() => {
    setHintText(hintTextProp);
    checkErrors(value);
  }, [hintTextProp]);
  useEffect(() => {
    if (defaultValue) onChangeTextHandler(defaultValue);
  }, []);
  useEffect(() => {
    if (value != valueProp) {
      if (preventOnChangeText) {
        setValue(valueProp);
      } else {
        onChangeTextHandler(valueProp);
      }
    }
  }, [valueProp]);
  var onHintPressHandler = () => {
    onHintActionPressHandler === null || onHintActionPressHandler === void 0 ? void 0 : onHintActionPressHandler();
  };
  var getInputContainerStyles = useCallback(event => {
    var styles = getInputStyles(Object.assign(Object.assign({}, inputProps), {
      state,
      useStateHintColor
    }), Object.assign(Object.assign({}, event), {
      focused: isInputFocused
    }));
    stylesBasedOnState.current = styles;
    return [styles.inputWrapper, style];
  }, [inputProps, isInputFocused, state, useStateHintColor]);
  var getPrependAppendItem = (isPrepend, data, style) => {
    var isPressable = showClearBtn || (data === null || data === void 0 ? void 0 : data.isPressable);
    var onPrependAppendItemPress = event => {
      var _a;
      if (blockEdit) return;
      if (showClearBtn) {
        setValue('');
        onClearButtonPress === null || onClearButtonPress === void 0 ? void 0 : onClearButtonPress();
      }
      (_a = data === null || data === void 0 ? void 0 : data.onPress) === null || _a === void 0 ? void 0 : _a.call(data, event);
    };
    return _jsx(InputPrependAppendItem, Object.assign({}, data, {
      theme: theme,
      variantStyle: variantStyle,
      size: size,
      isPrepend: isPrepend,
      style: style,
      disabled: disabledTextInput,
      readOnly: readOnlyTextInput,
      showLoader: showLoader,
      showClearButton: showClearBtn,
      isPressable: isPressable,
      onPress: onPrependAppendItemPress,
      readOnlyOnPress: readOnlyOnPress,
      inputProps: inputProps
    }, getTestId(testID)));
  };
  var onChangeTextHandler = text => {
    if (preventOnChangeText || prevValue === text) return;
    setPrevValue(text);
    if ((text === null || text === void 0 ? void 0 : text.length) > 0) {
      if (!inputRegex) {
        onChangeText === null || onChangeText === void 0 ? void 0 : onChangeText(text === null || text === void 0 ? void 0 : text.trimStart());
        setValue(text === null || text === void 0 ? void 0 : text.trimStart());
      } else {
        var testValue = text === null || text === void 0 ? void 0 : text.match(new RegExp(inputRegex));
        if (testValue) {
          onChangeText === null || onChangeText === void 0 ? void 0 : onChangeText(text);
          setValue(text);
        }
      }
      if (validationRegex) {
        if (typeof validationRegex === 'string') {
          var validInput = text.match(new RegExp(validationRegex, validationRegexFlag));
          if (validInput) {
            onValidInput === null || onValidInput === void 0 ? void 0 : onValidInput(text);
          } else {
            onInValidInput === null || onInValidInput === void 0 ? void 0 : onInValidInput(text, invalidMsgForValidationRegex);
          }
        } else {
          var errorMessage = '';
          for (var _iterator = _createForOfIteratorHelperLoose(validationRegex), _step; !(_step = _iterator()).done;) {
            var _step$value = _step.value,
              regex = _step$value.regex,
              message = _step$value.errorMessage,
              flag = _step$value.flag;
            var _validInput = text.match(new RegExp(regex, flag));
            if (!_validInput) {
              errorMessage = message;
              break;
            }
          }
          if (errorMessage) {
            onInValidInput === null || onInValidInput === void 0 ? void 0 : onInValidInput(text, errorMessage);
          } else {
            if (typeof validationRegex != 'string') {
              onValidInput === null || onValidInput === void 0 ? void 0 : onValidInput(text);
            }
          }
        }
      }
      checkErrors(text);
    } else {
      onInValidInput === null || onInValidInput === void 0 ? void 0 : onInValidInput(text);
      onChangeText === null || onChangeText === void 0 ? void 0 : onChangeText(text);
      setValue(text);
      if (validationRegex && invalidMsgForValidationRegex) {
        setHintText(hintTextProp);
        setUseStateHintColor(useStateHintColorProp);
        setState(stateProp);
      }
    }
  };
  var checkErrors = text => {
    if (text.length > 0 && validationRegex) {
      if (typeof validationRegex === 'string') {
        var validInput = text.match(new RegExp(validationRegex, validationRegexFlag));
        if (validInput) {
          setHintText(hintTextProp);
          setUseStateHintColor(useStateHintColorProp);
          setState(stateProp);
        } else {
          if (invalidMsgForValidationRegex) {
            setHintText(invalidMsgForValidationRegex);
            setUseStateHintColor(true);
            setState('error');
          }
        }
      } else {
        var errorMessage = '';
        for (var _iterator2 = _createForOfIteratorHelperLoose(validationRegex), _step2; !(_step2 = _iterator2()).done;) {
          var _step2$value = _step2.value,
            regex = _step2$value.regex,
            message = _step2$value.errorMessage,
            flag = _step2$value.flag;
          var _validInput2 = text.match(new RegExp(regex, flag));
          if (!_validInput2) {
            errorMessage = message;
            break;
          }
        }
        if (errorMessage) {
          setHintText(errorMessage);
          setUseStateHintColor(true);
          setState('error');
        } else {
          setHintText(hintTextProp);
          setUseStateHintColor(useStateHintColorProp);
          setState(stateProp);
        }
      }
    }
  };
  return _jsxs(View, Object.assign({
    style: containerStyle
  }, getTestId(testID), {
    pointerEvents: disabledTextInput ? 'none' : 'auto'
  }, {
    children: [variantStyle === 'default' && (label || (actionCta === null || actionCta === void 0 ? void 0 : actionCta.title)) && _jsxs(View, Object.assign({
      style: inputStyles.actionCtaContainer
    }, {
      children: [_jsxs(View, Object.assign({
        style: inputStyles.labelContainer
      }, {
        children: [!!label && _jsx(Typography, Object.assign({
          type: "body-single-line-xs",
          style: inputStyles.label,
          text: label
        }, labelAccessibilityProps, getTestId(testID, 'label'))), showLabelIcon && _jsx(Tooltip, Object.assign({
          theme: theme,
          position: 'top-start',
          offset: {
            x: -10,
            y: -6
          }
        }, labelTooltipProps, {
          isVisible: showLableTooltip,
          onClose: () => {
            if (labelTooltipProps === null || labelTooltipProps === void 0 ? void 0 : labelTooltipProps.autoHide) {
              setShowLableTooltip(false);
            }
          }
        }, getTestId(testID, 'showLableTooltip'), {
          children: _jsx(Pressable, Object.assign({
            onPress: () => {
              setShowLableTooltip(!showLableTooltip);
              onLabelIconPress === null || onLabelIconPress === void 0 ? void 0 : onLabelIconPress();
            }
          }, {
            children: _jsx(InfoIcon, Object.assign({
              fontSize: 16,
              style: inputStyles.infoIcon,
              color: BLUE_600
            }, getTestId(testID, 'infoIcon')))
          }))
        }))]
      })), !!(actionCta === null || actionCta === void 0 ? void 0 : actionCta.title) && _jsx(Button, Object.assign({
        buttonType: "tertiary"
      }, actionCta, {
        style: inputStyles.actionCta
      }, getTestId(testID, 'button')))]
    })), _jsx(Pressable, Object.assign({
      style: getInputContainerStyles,
      disabled: disabledTextInput,
      onPress: () => readOnlyOnPress === null || readOnlyOnPress === void 0 ? void 0 : readOnlyOnPress(),
      accessible: false
    }, checkIsPlatform('web') && {
      tabIndex: 1
    }, {
      children: () => {
        return _jsxs(_Fragment, {
          children: [showPrepend && getPrependAppendItem(true, Object.assign({}, prependItems), stylesBasedOnState.current.prepend), _jsxs(View, Object.assign({
            style: stylesBasedOnState.current.textInputContainer
          }, parentAccessibilityProps, {
            children: [variantStyle === 'withLabel' && !!label && _jsx(Typography, Object.assign({
              type: "body-single-line-xs",
              style: inputStyles.label,
              text: label
            }, labelAccessibilityProps, getTestId(testID, 'label'))), enableOtp ? _jsx(OtpFields, Object.assign({
              otpFieldLength: otpFieldLength,
              maskedLength: maskedLength,
              value: value
            }, inputProps, !readOnly && {
              onFocus: event => {
                _onFocus === null || _onFocus === void 0 ? void 0 : _onFocus(event);
                setIsInputFocused(true);
              }
            }, {
              onBlur: event => {
                _onBlur === null || _onBlur === void 0 ? void 0 : _onBlur(event);
                setIsInputFocused(false);
              },
              readOnly: readOnly,
              onChangeText: onChangeTextHandler
            })) : _jsx(TextInput, Object.assign({}, restProps, {
              ref: ref,
              onPressIn: evt => {
                var _a;
                (_a = restProps.onPressIn) === null || _a === void 0 ? void 0 : _a.call(restProps, evt);
                readOnlyOnPress === null || readOnlyOnPress === void 0 ? void 0 : readOnlyOnPress(evt);
              },
              cursorColor: stylesBasedOnState.current.cursorColor.backgroundColor
            }, !readOnly && {
              onFocus: event => {
                _onFocus === null || _onFocus === void 0 ? void 0 : _onFocus(event);
                setIsInputFocused(true);
              }
            }, {
              onBlur: event => {
                _onBlur === null || _onBlur === void 0 ? void 0 : _onBlur(event);
                setIsInputFocused(false);
              },
              style: stylesBasedOnState.current.textInput,
              pointerEvents: disabledTextInput ? 'none' : 'auto',
              editable: !blockEdit,
              value: value,
              placeholder: !hasPlaceholderList ? placeholder : '',
              onChangeText: onChangeTextHandler
            }, showAsTextArea && {
              numberOfLines: 3,
              multiline: true
            }, textInputOverrides, getTestId(testID, 'textInput'))), !value && hasPlaceholderList && _jsx(AnimatedPlaceholder, Object.assign({}, inputProps))]
          })), (showAppend || showLoader || showClearBtn) && getPrependAppendItem(false, appendItems, stylesBasedOnState.current.append)]
        });
      }
    })), (!!showCharacterCounter || !!hintText || !!hintActionText || !!showRemainingCharacterCounter) && _jsxs(View, Object.assign({
      style: inputStyles.hintContainer
    }, {
      children: [_jsxs(View, Object.assign({
        style: inputStyles.hintInnerContent
      }, {
        children: [!!hintText && _jsx(Typography, Object.assign({
          type: "body-para-xs",
          style: inputStyles.hint
        }, hintTextAccessibilityProps, {
          text: hintText
        }, getTestId(testID, 'hintText'))), !!hintActionText && _jsx(Pressable, Object.assign({
          onPress: onHintPressHandler,
          style: inputStyles.hintActionContainer,
          accessible: false
        }, {
          children: _jsx(Typography, Object.assign({
            type: "button-text-tertiary-sm",
            style: hintText && inputStyles.hintAction,
            text: hintActionText
          }, hintActionTextAccessibilityProps, {
            noTextTransform: noTextTransformHintAction
          }, getTestId(testID, 'hintActionText')))
        })), !!showRemainingCharacterCounter && _jsx(Typography, Object.assign({
          type: "body-para-xs",
          style: inputStyles.characterCounter,
          text: getRemainingCharacterCounter(Object.assign({
            value
          }, inputProps))
        }, getTestId(testID, 'showRemainingCharacterCounter')))]
      })), !!showCharacterCounter && _jsx(Typography, Object.assign({
        type: "body-para-xs",
        style: inputStyles.characterCounter,
        text: getCharacterCounter(Object.assign({
          value
        }, inputProps))
      }, getTestId(testID, 'showCharacterCounter')))]
    }))]
  }));
});